import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ReduxState } from '../store'
import { AuthState } from './reducer'
import { signIn } from './operations'
import { SignInParams } from '~/service/api'
import { resetSignInState } from './actions'

export type UseSignInResult = [
  AuthState,
  (params: SignInParams) => Promise<boolean>
]

export const useSignIn = (): UseSignInResult => {
  const dispatch = useDispatch()
  const signInState = useSelector<ReduxState, AuthState>((state) => state.auth)

  useEffect(() => {
    return () => {
      if (signInState.error) {
        dispatch(resetSignInState())
      }
    }
  }, [dispatch, signInState.error])

  const connectedSignIn = useCallback((params: SignInParams) => {
    return signIn(params)(dispatch)
  }, [dispatch])

  return [signInState, connectedSignIn]
}
